import { hot } from "react-hot-loader/root";
import React, { useState } from "react";
import Question from "./components/Question";

import { serializeForm } from "./utils/utils";
import { processQuiz } from "./utils/ajax";

const Quiz = () => {
  let quizForm = null;

  //==============================================
  //
  //  ##   ##   #####    #####   ##  ##   ####
  //  ##   ##  ##   ##  ##   ##  ## ##   ##
  //  #######  ##   ##  ##   ##  ####     ###
  //  ##   ##  ##   ##  ##   ##  ## ##      ##
  //  ##   ##   #####    #####   ##  ##  ####
  //
  //==============================================
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [quizIsOver, showQuizConclusion] = useState(false);
  const [isLoading, setLoading] = useState(false);

  //=====================================================
  //
  //  #####  ##   ##  #####  ##     ##  ######   ####
  //  ##     ##   ##  ##     ####   ##    ##    ##
  //  #####  ##   ##  #####  ##  ## ##    ##     ###
  //  ##      ## ##   ##     ##    ###    ##       ##
  //  #####    ###    #####  ##     ##    ##    ####
  //
  //=====================================================
  const onNextQuestionClick = () => {
    setCurrentQuestion(currentQuestion + 1);
  };

  const onPrevQuestionClick = () => {
    setCurrentQuestion(currentQuestion - 1);
  };

  const onSubmitQuiz = async (e) => {
    e.preventDefault();

    setLoading(true);

    const data = new FormData(
      document.querySelector("#pollux-quiz-final-app > form")
    );

    const result = await processQuiz(serializeForm(data));
    setLoading(false);

    showQuizConclusion(true);
  };

  //======================================
  //
  //  ##   ##    ###    #####     ####
  //  ##   ##   ## ##   ##  ##   ##
  //  ##   ##  ##   ##  #####     ###
  //   ## ##   #######  ##  ##      ##
  //    ###    ##   ##  ##   ##  ####
  //
  //======================================

  const questions = [...window.PolluxQuiz.quiz, { type: "lead" }];
  const pages = questions.length;
  const answers = [];

  if (quizIsOver) {
    return (
      <div className="quiz-conclusion">
        <p>
          La qualité d’un contôle d’accès se mesure à son maillon le plus
          faible… il suffit d’un accès oublié ou mal protégé pour fragiliser
          l’ensemble.
        </p>
        <p>
          Nous vous félicitons d’avoir rempli ce diagnostic car la sécurisation
          des accès est un enjeu d’autant plus important dans l’environnement
          actuel.
        </p>
        <p>
          Nous espérons que cet outil vous a permis de vous poser les bonnes
          questions. Si vous désirez poursuivre votre démarche et bâtir votre
          projet de sécurisation de vos accès nos experts sont disponibles pour
          vous accompagner
        </p>
        <p>
          D’après notre expérience, la gestion humaine des clés est souvent le
          point faible du système. Vous devez vous assurer que vous savez à qui
          vous avez remis vos clés et surtout que toutes les clés de vos anciens
          collaborateurs ont été récupérées. C’est souvent la plus grande faille
          de sécurité
        </p>
      </div>
    );
  }

  return (
    <section id="pollux-quiz-final-app" className={isLoading && "loading"}>
      <form ref={(form) => (quizForm = form)} onSubmit={onSubmitQuiz}>
        {questions.map((question, q) => (
          <div key={`question${q}`}>
            <Question
              question={question}
              first={q === 0}
              last={q === pages - 1}
              total={questions.length}
              current={q === currentQuestion}
              onNextClick={onNextQuestionClick}
              onPrevClick={onPrevQuestionClick}
              onSubmitClick={onSubmitQuiz}
              q={q}
            />
          </div>
        ))}
      </form>
      {isLoading && (
        <div className="loader">
          <p>Veuillez patienter...</p>
        </div>
      )}
    </section>
  );
};

export default hot(Quiz);
